export default __webpack_public_path__ + "images/6511ac5a11636f85ecd318b6c3a6e4ce-lock.svg";